import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router';
import { connect } from 'react-redux';
import { withStyles, MenuItem } from '@material-ui/core';
import { bindActionCreators } from 'redux';
import Translator from 'translator';
import { Toastr } from 'data/common';
import { logClientInterfaceConnection, refreshBox, restartBox, startVpn, stopVpn, updateBox } from '../../../data/Boxes/actions';
import selectors from '../selectors';
import { configureTendaRouter } from '../../../data/Homes/actions';

class ActionsMenu extends PureComponent {
    static propTypes = {
        startVpn: PropTypes.func.isRequired,
        stopVpn: PropTypes.func.isRequired,
        refreshBox: PropTypes.func.isRequired,
        handleLoading: PropTypes.func,
        restartBox: PropTypes.func.isRequired,
        updateBox: PropTypes.func.isRequired,
        logClientInterfaceConnection: PropTypes.func.isRequired,
        profile: PropTypes.object.isRequired,
        history: PropTypes.object.isRequired,
        clientInterface: PropTypes.string.isRequired,
        homeBox: PropTypes.object.isRequired,
        boxSwapAction: PropTypes.func
    };

    static defaultProps = {
        handleLoading: null,
        boxSwapAction: null
    };

    constructor(props) {
        super(props);
        this.state = {};
    }

    updateBox = () => {
        const { updateBox, homeBox, history } = this.props;

        Toastr.confirm(
            Translator.translate('generic.home.updateBox.confirmBoxUpdate', Translator.translate(`${history.environment}.centerName`)),
            Translator.translate('generic.home.updateBox.confirmBoxUpdateTitle', Translator.translate(`${history.environment}.centerName`)),
            {
                onYes: () => {
                    this.handleLoading(true);
                    return updateBox(homeBox.get('middleware'), homeBox.get('macAddress'))
                        .then(() => {
                            Toastr.success(
                                Translator.translate('generic.home.updateBox.success', Translator.translate(`${history.environment}.centerName`))
                            );
                        })
                        .catch(err => {
                            Toastr.error(
                                Translator.translateWithFallback(`socket.error.${err.message ? err.message : err}`, 'socket.error.defaultError'),
                                Translator.translate('generic.home.updateBox.error', Translator.translate(`${history.environment}.centerName`))
                            );
                        })
                        .finally(() => {
                            this.handleLoading(false);
                        });
                }
            }
        );
    };
    restartBox = () => {
        const { restartBox, homeBox, history } = this.props;

        Toastr.confirm(
            Translator.translate('generic.home.restartBox.confirmBoxRestart', Translator.translate(`${history.environment}.centerName`)),
            Translator.translate('generic.home.restartBox.confirmBoxRestartTitle', Translator.translate(`${history.environment}.centerName`)),
            {
                onYes: () => {
                    this.handleLoading(true);
                    return restartBox(homeBox.get('middleware'), homeBox.get('macAddress'))
                        .then(() => {
                            Toastr.success(
                                Translator.translate('generic.home.restartBox.success', Translator.translate(`${history.environment}.centerName`))
                            );
                        })
                        .catch(err => {
                            Toastr.error(
                                Translator.translateWithFallback(`socket.error.${err.message ? err.message : err}`, 'socket.error.defaultError'),
                                Translator.translate('generic.home.restartBox.error', Translator.translate(`${history.environment}.centerName`))
                            );
                        })
                        .finally(() => {
                            this.handleLoading(false);
                        });
                }
            }
        );
    };
    startVpn = () => {
        const { startVpn, homeBox } = this.props;
        this.handleLoading(true);
        return startVpn(homeBox.get('middleware'), homeBox.get('macAddress'))
            .then(() => {
                Toastr.success(Translator.translate('generic.home.startVpn.success'));
            })
            .catch(err => {
                Toastr.error(
                    Translator.translateWithFallback(`socket.error.${err.message ? err.message : err}`, 'socket.error.defaultError'),
                    Translator.translate('generic.home.startVpn.error')
                );
            })
            .finally(() => {
                this.handleLoading(false);
            });
    };
    stopVpn = () => {
        const { stopVpn, homeBox } = this.props;

        this.handleLoading(true);
        return stopVpn(homeBox.get('middleware'), homeBox.get('macAddress'))
            .then(() => {
                Toastr.success(Translator.translate('generic.home.stopVpn.success'));
            })
            .catch(err => {
                Toastr.error(
                    Translator.translateWithFallback(`socket.error.${err.message ? err.message : err}`, 'socket.error.defaultError'),
                    Translator.translate('generic.home.stopVpn.error')
                );
            })
            .finally(() => {
                this.handleLoading(false);
            });
    };
    clientInterface = () => {
        const { homeBox, logClientInterfaceConnection, clientInterface } = this.props;
        if (!clientInterface) {
            return Toastr.error(Translator.translate('generic.home.clientInterface.errorConfig'));
        }

        window.open(`${clientInterface}${homeBox.get('macAddress')}`);
        logClientInterfaceConnection(homeBox.get('boxId'));
    };
    refreshBox = () => {
        const { refreshBox, homeBox, history } = this.props;

        this.handleLoading(true);
        return refreshBox(homeBox.get('middleware'), homeBox.get('macAddress'))
            .then(() => {
                Toastr.success(Translator.translate('generic.home.refreshBox.success', Translator.translate(`${history.environment}.centerName`)));
            })
            .catch(err => {
                Toastr.error(
                    Translator.translateWithFallback(`socket.error.${err.message ? err.message : err}`, 'socket.error.defaultError'),
                    Translator.translate('generic.home.refreshBox.error', Translator.translate(`${history.environment}.centerName`))
                );
            })
            .finally(() => {
                this.handleLoading(false);
            });
    };

    boxSwap = () => {
        const { boxSwapAction } = this.props;
        boxSwapAction();
    };

    configureTendaRouter = () => {
        const { configureTendaRouter, homeBox } = this.props;

        this.handleLoading(true);
        return configureTendaRouter(homeBox.get('middleware'), homeBox.get('macAddress'), homeBox.get('boxId'))
            .then(SSID => {
                Toastr.success(Translator.translate('generic.home.configureTendaRouter.success'), SSID);
            })
            .catch(err => {
                Toastr.error(Translator.translate('generic.home.configureTendaRouter.error'), err);
            })
            .finally(() => {
                this.handleLoading(false);
            });
    }

    handleLoading = bool => {
        const { handleLoading } = this.props;
        if (handleLoading) handleLoading(bool);
    };

    render() {
        const { profile, history, boxSwapAction } = this.props;
        let menuItems = [];
        if (profile.get('admin') || profile.getIn(['user_rights', 'fhe'], []).includes('refreshBoxFhe')) {
            menuItems.push(
                <MenuItem key="refreshBox" onClick={this.refreshBox}>
                    {Translator.translate('generic.home.refreshBox.action', Translator.translate(`${history.environment}.centerName`))}
                </MenuItem>
            );
        }
        if (profile.get('admin') || profile.getIn(['user_rights', 'fhe'], []).includes('updateBoxFhe')) {
            menuItems.push(
                <MenuItem key="updateBox" onClick={this.updateBox}>
                    {Translator.translate('generic.home.updateBox.action', Translator.translate(`${history.environment}.centerName`))}
                </MenuItem>
            );
        }
        if (profile.get('admin') || profile.getIn(['user_rights', 'fhe'], []).includes('restartBoxFhe')) {
            menuItems.push(
                <MenuItem key="restartBox" onClick={this.restartBox}>
                    {Translator.translate('generic.home.restartBox.action', Translator.translate(`${history.environment}.centerName`))}
                </MenuItem>
            );
        }
        if (
            (boxSwapAction && profile.get('admin')) ||
            profile.getIn(['user_rights', 'fhe'], []).includes(`boxSwap`)
        ) {
            menuItems.push(
                <MenuItem key="boxSwap" onClick={this.boxSwap}>
                    {Translator.translate(`generic.home.boxSwap.action`, Translator.translate(`${history.environment}.centerName`))}
                </MenuItem>
            );
        }
        menuItems.push(
            <MenuItem key="configureTendaRouter" onClick={this.configureTendaRouter}>
                {Translator.translate(`generic.home.configureTendaRouter.action`, Translator.translate(`${history.environment}.centerName`))}
            </MenuItem>
        )
        if (profile.get('admin') || profile.getIn(['user_rights', 'fhe'], []).includes('startVpn')) {
            menuItems.push(
                <MenuItem key="startVpn" onClick={this.startVpn}>
                    {Translator.translate('generic.home.startVpn.action')}
                </MenuItem>
            );
        }
        if (profile.get('admin') || profile.getIn(['user_rights', 'fhe'], []).includes('stopVpn')) {
            menuItems.push(
                <MenuItem key="stopVpn" onClick={this.stopVpn}>
                    {Translator.translate('generic.home.stopVpn.action')}
                </MenuItem>
            );
        }
        if (profile.get('admin') || profile.getIn(['user_rights', 'fhe'], []).includes('clientInterface')) {
            menuItems.push(
                <MenuItem key="clientInterface" onClick={this.clientInterface}>
                    {Translator.translate('generic.home.clientInterface.action')}
                </MenuItem>
            );
        }

        return menuItems;
    }
}

function mapStateToProps(state) {
    return {
        profile: selectors.getProfile(state),
        clientInterface: selectors.getClientInterface(state)
    };
}

const styles = () => ({});

export default withRouter(
    connect(
        mapStateToProps,
        dispatch =>
            bindActionCreators(
                {
                    logClientInterfaceConnection,
                    refreshBox,
                    updateBox,
                    restartBox,
                    startVpn,
                    stopVpn,
                    configureTendaRouter
                },
                dispatch
            )
    )(withStyles(styles, { withTheme: true })(ActionsMenu))
);



// WEBPACK FOOTER //
// ./environments/fhe/scenes/Home/components/ActionsMenu.js